module.exports = __webpack_public_path__ + "static/img/02.4b48074.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/01/02.jpg
// module id = uvUO
// module chunks = 0